import { useBooleanState } from '@cian/react-utils';
import { ArticleParagraph3, Button, UIHeading5 } from '@cian/ui-kit';

import { clsx } from 'clsx';
import { FC, useCallback } from 'react';

import { stopPropagation } from 'shared/utils/event/stopPropagation';

import { HandlePhonesShow, PublisherPhoneButtonProps } from './types';

import styles from './PublisherPhoneButton.css';

export const PublisherPhoneButton: FC<PublisherPhoneButtonProps> = props => {
  const { phones, onPhonesShow, workHours, displayPhonesOptions } = props;

  const { state: opened, setTrue: setOpened } = useBooleanState();

  const handlePhonesShow = useCallback<HandlePhonesShow>(
    event => {
      setOpened();
      onPhonesShow(event);
    },
    [onPhonesShow, setOpened],
  );

  if (!phones.length) {
    return null;
  }

  if (opened) {
    const { countToDisplay, shouldDisplayWorkHours } = displayPhonesOptions;

    return (
      <div className={clsx(styles['phones'], styles['phones-animation'])} data-testid="publisher.phone-button.expanded">
        {phones.slice(0, countToDisplay).map(phone => (
          <UIHeading5 data-mark="PhoneValue" key={phone} onClick={stopPropagation}>
            {phone}
          </UIHeading5>
        ))}
        {shouldDisplayWorkHours && workHours && <ArticleParagraph3 color="gray60_100">{workHours}</ArticleParagraph3>}
      </div>
    );
  }

  return (
    <Button fullWidth data-testid="publisher.phone-button" size="XS" theme="fill_primary" onClick={handlePhonesShow}>
      {`${phones[0].slice(0, -2)}...`}
    </Button>
  );
};
